import { MDBBtn, MDBDatatable, MDBIcon, MDBRadio, MDBSelect } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddHolidays from "../../../views/popups/locations/AddHolidays";
import DeleteHoliday from "../../../views/popups/locations/DeleteHolidays";
import LocWeeklySchedule from "./LocWeeklySchedule";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import {
  createLunaSchedule,
  getMisc,
} from "../../../apiclients/streamsapi_bridge";
import WeelySchedulePopup from "../../CallFlows12/WeelySchedulePopup";

function LunaLocSchedule({
  register,
  setValue,
  getValues,
  unregister,
  holidaysList,
  locationid,
  setSuccessMessage,
  lunaid,
  allLocations,
  schedules,
  watch,
  reset,
  setenableHolidays,
  reqFromCallFlow,
  setreqFromCallFlow,
  errors,
  clearErrors,
  timezone,
  setRerender,
  customSchedule,
}) {
  const { t, i18n } = useTranslation();
  const [newSchedule, setNewSchedule] = useState(false);
  const [AddHoliday, setAddHoliday] = useState(false);
  const toggleShow18 = () => setAddHoliday(!AddHoliday);
  const [deleteHoliday, setDeleteHoliday] = useState(false);
  const toggleDelete = () => setDeleteHoliday(!deleteHoliday);
  const [holidays, setHolidays] = useState([]);
  const [addEditHolidays, setAddEditHolidays] = useState(false);
  const [modifiedObj, setModifiedObj] = useState({});
  const [editObj, setEditObj] = useState({});
  const [allowEdit, setAllowEdit] = useState(false);
  const [deleteHolidayId, setDeleteHolidayId] = useState("");
  const addHolidayRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [customSchID, setCustomSchID] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [scheduletype, setScheduletype] = useState(false)
  

  const handleFocus = () => setIsOpen(true);
  const handleBlur = () => setIsOpen(false);

  const autocompleteRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const toggleNewSchedule = () => {
    console.log(newSchedule);
    setNewSchedule(!newSchedule);
  };
  const weeklyFields = [
    {
      fieldLabel: t("sunday"),
      fieldValue: "sun",
    },
    {
      fieldLabel: t("monday"),
      fieldValue: "mon",
    },
    {
      fieldLabel: t("tuesday"),
      fieldValue: "tue",
    },
    {
      fieldLabel: t("wednesday"),
      fieldValue: "wed",
    },
    {
      fieldLabel: t("thursday"),
      fieldValue: "thu",
    },
    {
      fieldLabel: t("friday"),
      fieldValue: "fri",
    },
    {
      fieldLabel: t("saturday"),
      fieldValue: "sat",
    },
  ];

  function handleClick() {
    addHolidayRef.current.click();
  }
  useEffect(() => {
    if (customSchedule && Object.entries(customSchedule)?.length > 0 && schedules && schedules.length > 0) {
      console.log("schedules ::::::::::::: " + JSON.stringify(schedules));
      const id = (schedules.find((item) => parseInt(item.id) === parseInt(customSchedule.id) && item.schedule_type === customSchedule.type))?.value ?? 0;
      console.log(id)
      setCustomSchID(id);
    }

  }, [customSchedule, schedules])
  useEffect(() => {
    if (holidaysList && holidaysList.length > 0) {
      setHolidays(holidaysList);
    } else {
      setHolidays([]);
    }
  }, [holidaysList]);

  useEffect(() => {
    if (addEditHolidays && modifiedObj && Object.keys(modifiedObj).length > 0) {
      if (modifiedObj.isEdited) {
        delete modifiedObj.isEdited;
        // Filter out the existing object from whiteList and add the updated existObj
        const index = holidays.findIndex(
          (item) => item.holiday_id == modifiedObj.holiday_id
        );
        if (index != -1) {
          holidays.splice(index, 1, modifiedObj);
          if (setenableHolidays) {
            if (holidays.length > 0) {
              setenableHolidays(true);
            } else {
              setenableHolidays(false);
            }
          }
        }
      } else {
        const newHolidays = [...holidays, modifiedObj];
        setHolidays(newHolidays);
        if (setenableHolidays) {
          if (newHolidays.length > 0) {
            setenableHolidays(true);
          } else {
            setenableHolidays(false);
          }
        }
      }
    }
    if (addEditHolidays && deleteHolidayId != "") {
      const update = holidays.filter(
        (item) => item.holiday_id != deleteHolidayId
      );
      setHolidays(update);
      if (setenableHolidays) {
        if (update.length > 0) {
          setenableHolidays(true);
        } else {
          setenableHolidays(false);
        }
      }
      setDeleteHolidayId("");
    }
    if (reqFromCallFlow) {
      if (window.opener && window.opener.receiveMessageFromChild) {
        window.opener.receiveMessageFromChild(1); // Send a message to the parent
      }
      setreqFromCallFlow(false);
      window.close();
    }
    setAddEditHolidays(false);
  }, [addEditHolidays]);

  let proccessdRows = [];
  holidays &&
  holidays.map((holiday) => {
    const isDisabled = scheduletype;

  proccessdRows.push({
    holidayDetail: holiday,
    name: holiday.name,
    position: `From : ${holiday.from} To : ${holiday.to}`,
    disabled: isDisabled,
    className: isDisabled ? "disabled-row" : "",  // <-- ADD THIS

    action: (
      <div className="d-flex align-items-center ms-2">
        <div
          className={`custom-hover-bg p-1 cursor-pointer deleteToolTip ${isDisabled ? "disabled" : ""}`}
          onClick={(e) => {
            if (isDisabled) return;   // prevent click
            handleDelete(e, holiday.holiday_id);
          }}
        >
          <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
        </div>
      </div>
    ),
  });
});

  const basicData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Date and Time Range", field: "position" },
      { label: "Remove", field: "action", sort: false },
    ],
    rows: proccessdRows,
    pagination: false,
  };

  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.localSchedule-Table');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
  function handleDelete(e, id) {
    e.preventDefault();
    e.stopPropagation();
    setDeleteHolidayId(id);
    toggleDelete();
  }
  const handleScheduleDays = (day) => {
    const isChecked = getValues(`schedule.weekly_schedule.${day}.selected`);
    setValue(`schedule.weekly_schedule.${day}.selected`, !isChecked, {
      shouldDirty: true,
    });
  };
  function EditHoliday(event) {
    const holiday = event.holidayDetail;
    setEditObj({
      id: holiday.holiday_id,
      name: holiday.name,
      from: holiday.from,
      to: holiday.to,
    });
    setAllowEdit(true);
    toggleShow18();
  }

  const onNewSchedule = async (tnewObjInfo) => {
    const updates = {
      reqid: 60,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      timezone: tnewObjInfo.timezone,
      schedule: {
        all_time: tnewObjInfo.all_time,
        weekly_schedule: tnewObjInfo.weekly_schedule,
      },
      holidays: tnewObjInfo.holidays,
    };

    let saverep = await createLunaSchedule(
      updates,
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      lunaid
    );
    let saverepeMsg = await saverep.json();
    // setSuccessMessage(saverepeMsg.message);
    setRerender(true)
    setSuccessMessage(saverepeMsg.message);
    // window.location.reload();

    if (saverepeMsg.message.errors && saverepeMsg.message.errors.length > 0) {
      return;
    }
  };

  async function fetchScheduleDetails(locid, schedule_type, ext) {
    if (ext.value === -1 && ext.text === "Create New") {
      handleBlur();
      toggleNewSchedule();

      return;
    }
    handleBlur();
    console.log("schedules ::::::::::::::::: " + JSON.stringify(schedules));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["luna_loc"],
        lunaid: lunaid,
        loc_id: parseInt(locid),
        iscustom: schedule_type,
      }
    );
    if (!response.json) {
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const lunaDetails = tdata?.misc ?? {};
    // console.log("luna details ::::")
    setHolidays(lunaDetails?.holidays ?? []);
    // setschid(parseInt(locid))
    reset((prev) => ({
      ...prev,
      schedule: {
        all_time: lunaDetails?.schedule?.all_time ?? false,
        weekly_schedule: {
          sun: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.sun?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.sun?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.sun?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.sun?.twenty_four ?? false,
          },
          mon: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.mon?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.mon?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.mon?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.mon?.twenty_four ?? false,
          },
          tue: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.tue?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.tue?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.tue?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.tue?.twenty_four ?? false,
          },
          wed: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.wed?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.wed?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.wed?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.wed?.twenty_four ?? false,
          },
          thu: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.thu?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.thu?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.thu?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.thu?.twenty_four ?? false,
          },
          fri: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.fri?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.fri?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.fri?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.fri?.twenty_four ?? false,
          },
          sat: {
            selected:
              lunaDetails?.schedule?.weekly_schedule?.sat?.selected ?? false,
            from_time:
              lunaDetails?.schedule?.weekly_schedule?.sat?.from_time ?? "",
            to_time: lunaDetails?.schedule?.weekly_schedule?.sat?.to_time ?? "",
            twenty_four:
              lunaDetails?.schedule?.weekly_schedule?.sat?.twenty_four ?? false,
          },
        },
        schedule_id: lunaDetails?.schedule?.sch_loc_id ?? false,
        schedule_type: lunaDetails?.schedule?.iscustom,
      },
    }));
    setValue("schedule.sch_loc_id", locid, {
      shouldDirty: true,
    });
    setValue("schedule.schedule_type", schedule_type, {
      shouldDirty: true,
    });
    setCustomSchID(ext.value);
  }

  return (
    <>
      {getValues("schedule.schedule_type") > 1 && (
        <>
          <div id="weeklyschedule">
            <div className="general-settings">{t("Weekly Schedule")}</div>
            <div className="d-flex align-items-center justify-content-between">

              <div className="d-flex align-items-center">
                <strong> Current Schedule:</strong>&nbsp;&nbsp;
                {!getValues("schedule.all_time") && <>Weekly</>}
                {getValues("schedule.all_time") && <>24/7</>}
                <div className="ms-3 d-flex">
                  {timezone && (
                    <p className="mb-0">
                      <strong>Timezone:</strong> {timezone}
                    </p>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center flex-grow-1 justify-content-end">
                {schedules && schedules.length > 0 && lunaid && (
                  <MDBSelect
                    className="w-30"
                    title={schedules.find(schedule => schedule.value === parseInt(customSchID))?.text || "Select Schedule"}
                    name="San Jose"
                    search
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    data={schedules}
                    value={parseInt(customSchID)}
                    onChange={(e) => {
                      if (
                        e &&
                        e.value &&
                        parseInt(watch("schedule.sch_loc_id")) !==
                        parseInt(e.id)
                      ) {
                        fetchScheduleDetails(
                          parseInt(e.id),
                          e.schedule_type,
                          e
                        );
                      }
                    }}
                  />
                )}{" "}
                {/* &nbsp;&nbsp;
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleNewSchedule();
                  }}
                >
                  <MDBIcon fas icon="plus" color="white" /> Create New Schedule
                </MDBBtn> */}
              </div>
            </div>


            {/* <div className="d-flex justify-content-between border-0 mt-3">
              <strong>
                <h6 className="my-2">{t("Holidays")}</h6>
              </strong>
            </div>
            <div className="addHolidayLoc">
              <MDBDatatable
                data={basicData}
                pagination={false}
                sortField="Name"
              />
            </div> */}
          </div>
        </>
      )}
       {parseInt(getValues("schedule.sch_loc_id")) > 0 && (
        <>
          <div id="weeklyschedule">
            <div className="general-settings">{t("Weekly Schedule")}</div>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center justify-content-end">
                <div className="d-flex align-items-center">
                  <MDBRadio
                    name="inlineRadio"
                    id="inlineRadio1"
                    disabled = {scheduletype}
                    value={true}
                    label="24/7"
                    inline
                    checked={getValues("schedule.all_time")}
                    onChange={() =>
                      setValue("schedule.all_time", true, { shouldDirty: true })
                    }
                  />
                  <MDBRadio
                    name="inlineRadio"
                    id="inlineRadio2"
                    disabled = {scheduletype}
                    value={false}
                    label="Weekly Schedule"
                    inline
                    checked={!getValues("schedule.all_time")}
                    onChange={() =>
                      setValue("schedule.all_time", false, { shouldDirty: true })
                    }
                  />
                </div>
              </div>


              <div className="d-flex align-items-center flex-grow-1 justify-content-end" ref={autocompleteRef} title={parseInt(customSchID)}>
                {schedules && schedules.length > 0 && lunaid && (
                  <MDBSelect
                    className="w-30"
                    name="San Jose"
                    search
                    title={schedules.find(schedule => schedule.value === parseInt(customSchID))?.text || "Select Schedule"}
                    // open={isOpen}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    data={schedules}
                    value={parseInt(customSchID)}
                    onChange={(e) => {
                      if (!e || !e.value) return;
                      const selected = schedules.find(
                        (s) => parseInt(s.value) === parseInt(e.value)
                      );
                      setScheduletype(parseInt(selected?.schedule_type) !== 1);
                      setCustomSchID(e.value);
                      if (parseInt(watch("schedule.sch_loc_id")) !== parseInt(e.id)) {
                        fetchScheduleDetails(
                          parseInt(e.id),
                          selected?.schedule_type,   // send correct schedule_type
                          e
                        );
                      }
                    }}
                  />
                )}{" "}
                {/* &nbsp;&nbsp;
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleNewSchedule();
                  }}
                >
                  <MDBIcon fas icon="plus" color="white" /> Create New Schedule
                </MDBBtn> */}
              </div>
            </div>

            {/* <div className="d-flex align-items-center">
              <strong> Current Schedule:</strong>&nbsp;&nbsp;
              {!getValues("schedule.all_time") && <>Weekly</>}
              {getValues("schedule.all_time") && <>24/7</>}
              <div className="ms-3 d-flex">
                {timezone && (
                  <p className="mb-0">
                    <strong>Timezone:</strong> {timezone}
                  </p>
                )}
              </div>
            </div> */}
            {!getValues("schedule.all_time") && (
              <>
                <div className="row">
                  <div className=" w-100">
                    {weeklyFields.map((item) => (
                      <LocWeeklySchedule
                        key={item.fieldValue}
                        register={register}
                        getValues={getValues}
                        setValue={setValue}
                        unregister={unregister}
                        checkedSelected={`schedule.weekly_schedule.${item.fieldValue}.selected`}
                        twentyFourFlag={`schedule.weekly_schedule.${item.fieldValue}.twenty_four`}
                        fromTime={`schedule.weekly_schedule.${item.fieldValue}.from_time`}
                        toTime={`schedule.weekly_schedule.${item.fieldValue}.to_time`}
                        fieldLabel={item.fieldLabel}
                        errors={errors}
                        clearErrors={clearErrors}
                        watch={watch}
                        disabled={scheduletype}
                      />
                    ))}
                  </div>
                </div>
              </>
            )}
            { getValues("schedule.schedule_type") == 1 && (
            <div className="d-flex justify-content-between border-0 mt-3">
              <h6 className="my-2">{t("Holidays")}</h6>
              <MDBBtn
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setEditObj({});
                  setAllowEdit(false);
                  toggleShow18();
                }}
              > 
                <MDBIcon fas icon="plus" color="white" /> Add Holiday
              </MDBBtn>
            </div>
             )} 

            <div className="addHolidayLoc">
              <MDBDatatable
                className="actioncolumn localSchedule-Table"
                onRowClick={(row) => {
                  if (row.disabled) return;
                  EditHoliday(row);
                }}

                data={basicData}
                pagination={false}
                sortField="Name"

              />
            </div>
          </div>

          {deleteHoliday && (
            <PopupLoaderNew
              size="md"
              className="small-popup"
              title={t("Remove Holidays")}
              content={
                <DeleteHoliday
                  onClose={toggleDelete}
                  locationid={locationid}
                  setSuccessMessage={setSuccessMessage}
                  addEditFlag={setAddEditHolidays}
                  deleteHolidayId={deleteHolidayId}
                  ref={addHolidayRef}
                  setIsloading={setisLoading}
                  schedule_id={getValues("schedule.sch_loc_id")}
                  lunaid={lunaid}
                />
              }
              onShow={setDeleteHoliday}
              onClose={toggleDelete}
              onSave={handleClick}
              isloading={isLoading}
              flag={4}
            />
          )}

          {AddHoliday && (
            <PopupLoaderNew
              size="md"
              className="small-popup"
              title={allowEdit ? "Edit Holiday" : t("addHoliday")}
              content={
                <AddHolidays
                  onClose={toggleShow18}
                  locationid={locationid}
                  setSuccessMessage={setSuccessMessage}
                  addEditFlag={setAddEditHolidays}
                  modifyObj={setModifiedObj}
                  isEdit={allowEdit}
                  editObj={editObj}
                  ref={addHolidayRef}
                  setIsloading={setisLoading}
                  lunaid={lunaid}
                  schedule_id={getValues("schedule.sch_loc_id")}
                />
              }
              onShow={setAddHoliday}
              onClose={toggleShow18}
              onSave={handleClick}
              isloading={isLoading}
              flag={allowEdit ? 2 : 1}
            />
          )}

          <Tooltip
            anchorSelect=".deleteToolTip"
            place="top"
            className="exampleTooltip"
          >
            Remove
          </Tooltip>

        </>

      )}
      {newSchedule && (
        <PopupLoader
          size="lg"
          className="modal-lg"
          title="Create New Schedule"
          content={
            <WeelySchedulePopup
              onCreate={onNewSchedule}
              isLuna={true}
              onClose={() => toggleNewSchedule()}
            />
          }
          onShow={setNewSchedule}
          open={newSchedule}
          onClose={() => toggleNewSchedule()}
        />
      )}
    </>
  );
}

export default LunaLocSchedule;
